import script from "./HospitalForgotPassword.vue?vue&type=script&setup=true&lang=ts"
export * from "./HospitalForgotPassword.vue?vue&type=script&setup=true&lang=ts"

import "./HospitalForgotPassword.vue?vue&type=style&index=0&id=10dba1ae&lang=css"

const __exports__ = script;

export default __exports__